export default __webpack_public_path__ + "static/media/logo.98c8dd83.svg";